// Auto-generated posts content
// Generated from .txt files in src/assets/posts/
// Run 'python generate_posts.py' to regenerate this file

const posts = {
  "posts-2": {
    id: "posts-2",
    title: "I actually take a break!",
    date: "Feb 02 2026",
    publishedAt: "2026-02-02",
    lastModified: "2026-02-02T02:48:53.504328",
    content: [
      {
        type: "paragraph",
        text: "Spirit Falls volume 1 has officially ended! You can give your thoughts on it here—please!: https://forms.gle/z4x9vnhq1vNFWtbCA",
        align: "left",
        segments: [
          { type: "text", value: "Spirit Falls volume 1 has officially ended! You can give your thoughts on it here—please!: " },
          { type: "link", url: "https://forms.gle/z4x9vnhq1vNFWtbCA", text: "https://forms.gle/z4x9vnhq1vNFWtbCA" }
        ]
      },
      {
        type: "paragraph",
        text: "Spirit Falls has gone through some massive changes recently, mostly in prioritizing volume-release coherency more than month-to-month monthly deadlines, and letting me expand pagecount massively. A consistent release full-moon-ly schedule will remain, but with strategic mini-hiatuses of only a couple months between batches so I don't die. Turns out? Nobody wants to read this shit monthly anyway! I'm still working on self-publishing volume 1, but with this in mind, some minor changes are knocking around in my head that will put volume 1 much more in line with future content. It might even make it good! Or maybe it already is? I don't know, that's why you need to do the fucking survey!!!!!!",
        align: "left"
      },
      {
        type: "paragraph",
        text: "Volume 2 will begin on May 1st, with an additional chapter on May 31st under the blue moon! This all builds to chapter 17, the FALLSNUKE, dropping July 7th to commemmorate Luna's birthday. Mark your calendars! Nothing will ever be the same! The story's good now-- swear to god! Survey! Survey! Take my survey! God!!! Please!!!!!!! It's all I have!",
        align: "left"
      }
    ]
  },
  "about": {
    id: "about",
    title: "About",
    lastModified: "2025-10-04T14:51:40.695914",
    content: [
      {
        type: "paragraph",
        text: "Burned out from her animation course in L.A, Luna Chance takes a vacation to meet her friend Brooke in person for the first time. Traveling to a town so remote it's almost off the map, Luna finds that Brooke and the cursed town of Spirit Falls hold secrets that will change her view of the world forever. Maybe even enough to pass her next semester, if it doesn't kill her first.",
        align: "center"
      },
      {
        type: "paragraph",
        text: "A new 12+ page chapter releases once every single month on the day of the full moon.",
        align: "center"
      },
      {
        type: "paragraph",
        text: "_________________________",
        align: "center"
      },
      {
        type: "paragraph",
        text: "Spirit Falls is About many things. Some might even say it’s about everything. But most importantly it’s about life, legacy, and lesbians.",
        align: "left"
      },
      {
        type: "paragraph",
        text: "Spirit Falls is an urban-fantasy mystery series that takes heavy inspiration from Life is Strange, Jojo’s Bizarre Adventure, and Gravity Falls. (The last one was a coincidence, I swear it.)",
        align: "left"
      },
      {
        type: "paragraph",
        text: "I wanted to mix the big, bizarre, magic fighting of fantasy and bring it back down to earth. What sets Spirit Falls apart from other urban fantasy is, to me at least, the intimacy in the smallest moments. A feeling you can’t quite name. “It.”",
        align: "left"
      },
      {
        type: "paragraph",
        text: "The gravitas given to ordinary life and to mortal danger should be equal. And this means the pacing is slow. Spirit Falls is a 10 year project most likely, if not more, and I knew this going into it. This comic is my life, in every sense. I’m someone who always needs a purpose, and now I’ve made one. I guess Spirit Falls is about this too. My promise is that no matter what, you will get an answer. I am not someone who abandons things. It may take forever, but month-by-month, you will be closer to eventually finding out who killed Wanda Leech. And if I do everything right, you might even understand “it.”",
        align: "left"
      }
    ]
  },
  "posts-1": {
    id: "posts-1",
    title: "Welcome to Spirit Falls!",
    date: "Oct 04 2025",
    publishedAt: "2025-10-04",
    lastModified: "2026-02-02T02:48:53.504328",
    content: [
      {
        type: "paragraph",
        text: "Global Comix’s #3* comic has finally struck out on its own! And none of this would have been possible without my buddy Corran. The front page posts will be updated over time, but above all else: remember to check back for a new chapter on every full moon!",
        align: "left"
      },
      {
        type: "paragraph",
        text: "To learn what Spirit Falls is, or what it’s About, there’s the About page, which is fortuitous. The Support page just links to the Patreon for now, if you want early access to the chapters 1-2 months ahead of time and access to the bonus art.",
        align: "left"
      },
      {
        type: "paragraph",
        text: "The chapters page of course takes you to the chapters reader, which also links to my social media accounts. And this home page will have semi-frequent updates for news, scheduling, or (god forbid) hiatuses. There will be a proper release calendar here someday too, but for now, the release dates are:",
        align: "left"
      },
      {
        type: "paragraph",
        text: "October 4th, November 6th, December 5th, January 5th, and February 2nd.",
        align: "left"
      },
      {
        type: "paragraph",
        text: "This will be the end of “volume 1” of Spirit Falls, and there might be a one-or-two month hiatus between volumes  as I organize a print run. The future is bright for Spirit Falls!",
        align: "left"
      },
      {
        type: "footnote",
        text: "*(#3 most popular independently created comic in the crime genre for 2024. You can see how that may be less impressive.)",
        align: "left"
      }
    ]
  }
};

// Export individual posts for convenience
export const posts_2Post = posts["posts-2"];
export const aboutPost = posts["about"];
export const posts_1Post = posts["posts-1"];

export default posts;
